import type { StatusChangeResponse } from '../api/responses.js';

export const EDITABLE_STATUS = 'DRAFT';

interface EditableCandidate {
  currentStatus?: string | null | undefined;
  statusHistory?: Pick<StatusChangeResponse, 'toStatus'>[] | null | undefined;
}

export function isCertificateEditable({
  currentStatus,
  statusHistory,
}: EditableCandidate): boolean {
  const status = currentStatus || statusHistory?.[statusHistory.length - 1]?.toStatus;

  return Boolean(status) && String(status).toUpperCase() === EDITABLE_STATUS;
}
